import { memo, useState } from "react";
import styles from './code.module.scss';
import TextFieldShared from "../../../components/TextField/TextField";
import CheckboxShared from "../../../components/Checkbox/Checkbox";
import { CodeProps } from "../../../interfaces/app"

const Code = ({ 
    handlePress, 
    code, 
    setCode, 
    password, 
    setPassword
}: CodeProps) => {

    return (
        <div className={styles.codeContent}>
            <div className={styles.inputs}>
                <TextFieldShared
                    label="Código"
                    name="code"
                    value={code?.value}
                    error={code?.error}
                    onChange={(value: any) => setCode({...code, value: value})}
                    onEnter={handlePress}
                    autoFocus
                />
                <TextFieldShared
                    type="password"
                    label="Contraseña"
                    name="password"
                    value={password?.value}
                    error={password?.error}
                    onChange={(value: any) => setPassword({...password, value: value?.value, validation: value?.passValidate})}
                    className={styles.full}
                />
            </div>
        </div>
    )
}

export default memo(Code);